import { gql, useMutation } from '@apollo/client'

const CONTENT_REPORT_CREATE = gql`
  mutation ContentReportCreate($input: ContentReportInputObject!) {
    contentReportCreate(input: { input: $input }) {
      contentReport {
        id
        reason
        status
        courseId
        createdAt
      }
      status
    }
  }
`

interface IContentReportInput {
  schoolProductId: string
  courseId: string
  lessonId?: string
  courseContentId?: string
  reason: string
}

interface IContentReportResult {
  contentReportCreate: {
    contentReport: {
      id: string
      reason: string
      status: string
      courseId: string
      createdAt: string
    } | null
    status: 'created' | 'already_reported'
  }
}

export const useContentReportCreate = () => {
  const [createReport, { loading, error }] = useMutation<IContentReportResult>(
    CONTENT_REPORT_CREATE,
  )

  const handleCreateReport = async (input: IContentReportInput) => {
    const response = await createReport({
      variables: { input },
    })
    return response.data?.contentReportCreate
  }

  return { handleCreateReport, loading, error }
}
